<template>
  <div class="order-page">
    <unloading-order-stats :time-range="searchTimeRange" />
    <div class="order-list" v-loading="loadingOrder">
      <el-tabs v-model="curTab" @tab-click="selectTabChange">
        <el-tab-pane
          v-for="(tab, index) in Tabs"
          :key="'order-tab-' + index"
          :label="tab"
          :name="tab"
        />
      </el-tabs>
      <searchable-table
        :table-headers="UnloadingOrderTableHeaders"
        :table-data="orderPage"
        :search-params="searchForm"
        :search-param-change="searchParamChange"
      />
    </div>
  </div>
</template>
<script>
// mixins
import { pageJumps } from '@/core/mixin/pages'
// apis
import { queryOrders } from '@/api/order'
import { queryJobs } from '@/api/job'
// models
import {
  UnloadingOrderSearchForm,
  UnloadingOrderTableHeaders,
  UnloadingOrderSearchParamsWrapUp
} from '@/core/models/order'
import { UnloadingJob } from '@/core/models/constant'
// components
import SearchableTable from '@/components/common/SearchableTable.vue'
import UnloadingOrderStats from '@/components/order/UnloadingOrderStats.vue'
import { getMonth, getWeek } from '@/core/utils'
import { InitSearchForm } from '@/core/configs/types'

// tabs
const ThisWeek = 'This Week'
const ThisMonth = 'This Month'
export default {
  name: 'OrderUnloadingPage',
  mixins: [pageJumps],
  components: {
    SearchableTable,
    UnloadingOrderStats
  },
  data() {
    return {
      UnloadingOrderSearchForm,
      UnloadingOrderTableHeaders,
      loadingOrder: false,
      searchForm: InitSearchForm(
        UnloadingOrderSearchForm,
        UnloadingOrderTableHeaders
      ),
      orderPage: {},
      searchTimeRange: [],
      curTab: ThisWeek
    }
  },
  watch: {
    queryTab: {
      handler() {
        switch (this.queryTab) {
          case ThisWeek:
            this.searchTimeRange = getWeek()
            break
          case ThisMonth:
            this.searchTimeRange = getMonth()
            break
        }
        this.curTab = this.queryTab
        this.doOrderSearch()
      },
      immediate: true
    }
  },
  computed: {
    Tabs() {
      return [ThisWeek, ThisMonth]
    },
    queryTab() {
      return this.$route.query?.tab ?? ThisWeek
    }
  },
  methods: {
    selectTabChange() {
      this.goToSearchUnloadingOrder({ tab: this.curTab })
    },
    searchParamChange(key, path, value) {
      this.searchForm[key].value = value
      if (key === 'type') {
        this.curTab = value
        this.selectTabChange()
        return
      }
      this.doOrderSearch()
    },
    async doOrderSearch() {
      const searchForm = UnloadingOrderSearchParamsWrapUp(this.searchForm)
      searchForm.createdTimeRange = this.searchTimeRange
      this.loadingOrder = true
      const orderPage = await queryOrders(searchForm)
      await this.doUnloadingJobSearch(orderPage)
      this.loadingOrder = false
    },
    async doUnloadingJobSearch(orderPage) {
      const orderIds = orderPage.records.map(order => order.id)
      if (orderIds.length > 0) {
        const jobsPage = await queryJobs({
          orderIds,
          types: [UnloadingJob],
          size: orderIds.length
        })
        const jobs = jobsPage?.records ?? []
        jobs.forEach(job => {
          const order = orderPage.records.find(one => one.id === job.orderId)
          if (!order) {
            throw new Error('queried jobs contains no order in order list')
          } else {
            order.unloadingJob = job
          }
        })
      }
      this.$set(this, 'orderPage', orderPage)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.order-page {
  width: 100%;
  overflow-x: hidden;

  @extend .f-c;

  .features {
    @extend .global-margin;
  }

  .order-list {
    @extend .global-margin;
    @extend .shadow-level-three;

    border-radius: $home-card-border-radius;
    padding: $home-card-padding-y $home-card-padding-x;
    background-color: white;
  }
}
</style>
